import React, { Fragment, useState } from 'react';
import { ReactComponent as MenuIcon } from 'assets/icons/menu.svg';
import { ReactComponent as TrashIcon } from 'assets/icons/trash.svg';
import { ReactComponent as EditIcon } from 'assets/icons/edit.svg';
import DeleteManagerModal from '../managers-modal/delete-manager-modal';
import EditManagerModal from '../edit-manager-modal';
import { Dropdown } from '@cokitchen/cokitchen-components';
import { RiderType } from 'models/rider.model';
import { UserType } from 'models/user.model';
import { withDropdownList } from 'components/base/dropdown-list';
import { getUserName } from 'utils/functions';

type Props = {
  managers: RiderType[];
};

const DropdownList = withDropdownList<{
  name: string;
  onClick: () => void;
}>();

const ManagerInfo = ({ managers }: Props) => {
  const [showEditManagerModal, setShowEditManagerModal] = useState(false);
  const [showDeleteManagerModal, setShowDeleteManagerModal] = useState(false);
  const [activeManager, setActiveManager] = useState({} as UserType);
  const editDetails = () => {
    setShowEditManagerModal(!showEditManagerModal);
  };

  const deleteManager = () => {
    setShowDeleteManagerModal(!showDeleteManagerModal);
  };
  const DEFAULT_LIST_OPTIONS = [
    {
      name: 'Edit details',
      icon: <EditIcon />,
      onClick: editDetails
    },
    {
      name: 'Delete manager',
      icon: <TrashIcon />,
      onClick: deleteManager,
      className: 'text-[#E60A2B]'
    }
  ];
  return (
    <Fragment>
      <div className='flex justify-between gap-1 flex-wrap'>
        {managers.map((item, index) => (
          <div key={item?.id} className='w-[230px] my-2'>
            <div
              style={{
                backgroundColor: ' rgb(48,100,150)',
                backgroundImage:
                  index % 2 === 0
                    ? `linear-gradient(to right bottom, #3fabfd, #349fff, #3e91ff, #5481ff, #6f6eff)`
                    : `linear-gradient(to right top, #3083a7, #2074a1, #1c649a, #245390, #304284)`
              }}
              className='w-full h-[85px] rounded-t-lg p-4'>
              <Dropdown
                content={
                  <MenuIcon
                    onClick={() => setActiveManager(item)}
                    className='bg-black bg-opacity-40 w-7 h-7 p-[7px] rounded-full cursor-pointer transition-all duration-200 hover:bg-gray-6 text-white ml-auto '
                  />
                }>
                <DropdownList list={DEFAULT_LIST_OPTIONS} onSelect={(menu) => menu.onClick()} />
              </Dropdown>
            </div>
            <div className='py-3 h-[110px] px-3 border-[0.7px] border-[#E3E6E8]  rounded-b-lg flex flex-col justify-center space-y-1'>
              <p className='font-medium'>{getUserName(item)}</p>
              <div className='text-sm text-gray-8'>
                <p className='break-words'>{item?.email}</p>
                <p>{item?.phone_number}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
      <DeleteManagerModal
        show={showDeleteManagerModal}
        onClose={deleteManager}
        manager={activeManager}
      />
      <EditManagerModal show={showEditManagerModal} onClose={editDetails} manager={activeManager} />
    </Fragment>
  );
};

export default ManagerInfo;
